import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import HiddenViewModelType from '@/ViewModels/Controls/HiddenViewModel';

export default class Hidden extends Control {

    private jQueryControl: JQuery;

    public constructor(private viewModel: HiddenViewModelType, private element?: JQuery) {
        super(viewModel, element);

        this.onWidgetCreated(this.onWidgetCreatedCallback.bind(this));
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<input type="hidden">');

        this.widget(null);

        return this.jQueryControl;
    }

    private onWidgetCreatedCallback(widget: null): void {
        this.applyBindings(this.jQueryControl, {
            controlName: 'hidden',

            loader: this.viewModel.isBusy,

            controlIdent: this.identifier,

            tooltip: this.viewModel.tooltip,

            invalid: this.viewModel.invalidationText,

            value: this.viewModel.value
        });
    }
}

ComponentManager.setControl('Hidden', Hidden, 'RADPresentation.HTMLClient.DefaultViewExtensions');